import React, { useState } from "react";
import Fade from "react-reveal/Fade";

const ContactHero = () => {
  const [btnLoad, setBtnLoad] = useState(false);
  const [btnSent, setBtnSent] = useState(false);

  async function sendEmail(e) {
    e.preventDefault();
    setBtnLoad(true);
    setBtnSent(false);

    const endpoint =
      "https://rubszyfzpriu6slmpndhsmgdrm0jixyz.lambda-url.eu-west-2.on.aws/";

    const formEl = e.target;
    const formData = new FormData(formEl);

    const payload = {
      name: formData.get("name"),
      email: formData.get("email"),
      subject: formData.get("subject"),
      message: formData.get("message"),
    };

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error(`Contact endpoint returned ${res.status}`);
      }

      // Keep the existing UX delay for button state.
      setTimeout(() => {
        setBtnLoad(false);
        setBtnSent(true);
      }, 1000);
    } catch (err) {
      console.error(err);
      setBtnLoad(false);
    }

    formEl.reset();
  }

  return (
    <section className="contact--hero">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <Fade duration={1500} delay={0}>
              <div className="hero__heading">
                <h1>
                  How can we <br />
                  help?
                </h1>
              </div>
            </Fade>
            <Fade duration={1500} delay={200}>
              <div className="hero__subheading">
                <h6>
                  We’re ready to help you discover what your data can do for
                  you. Ask away...
                </h6>
              </div>
            </Fade>
          </div>

          <div className="col-12 col-lg-5">
            <form className="contact--hero__form" onSubmit={sendEmail}>
              <Fade duration={1500} delay={0}>
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  required
                ></input>
              </Fade>
              <Fade duration={1500} delay={50}>
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  required
                ></input>
              </Fade>
              <Fade duration={1500} delay={100}>
                <input
                  type="text"
                  placeholder="Subject"
                  name="subject"
                  required
                ></input>
              </Fade>
              <Fade duration={1500} delay={150}>
                <textarea
                  placeholder="Message"
                  name="message"
                  required
                ></textarea>
              </Fade>
              <Fade duration={1500} delay={200}>
                <button
                  className={`contact--button ${btnLoad ? "onclic" : ""} ${
                    btnSent ? "validate" : ""
                  }`}
                ></button>
              </Fade>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
